import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DayDatePicker = ({ label, day, setDay, style }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["DatePicker"]}
        sx={{
          "&.MuiStack-root": [
            style,
            {
              paddingTop: "0",
            },
          ],
        }}
      >
        <DatePicker
          label={label}
          onChange={(e) => setDay(e)}
          value={day}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              sx: {
                height: 40,
                backgroundColor: "white",
                "& .MuiInputBase-root": {
                  height: 40,
                  borderRadius: 2,
                  maxWidth: "160px",
                },
                "& .MuiInputBase-input": {
                  padding: "0 14px", 
                },
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DayDatePicker;
